import BaseApi from "./BaseApi";

class SupportRequestApi extends BaseApi {
  constructor() {
    super("support-requests");
  }
}

export default SupportRequestApi;
